import React, { Fragment, useState } from 'react';
import './Workflow.scss'
import ClientInterviewTask from './tasks/ClientInterviewTask'
import HrbTranslate from '../../../../components/language/HrbTranslate';
import IdentityConfirmationTask from './tasks/IdentityConfirmationTask';
import AuthorizationTask from './tasks/AuthorizationTask';
import DocumentUploadTask from './tasks/DocumentUploadTask';
import PrepareReturnTask from './tasks/PrepareReturnTask';
import ReviewReturnTask from './tasks/ReviewReturnTask';
import PaymentTask from './tasks/PaymentTask';
import FileReturnTask from './tasks/FileReturnTask';
import SkeletonTask from '../../../../components/library/workflow-tasks/SkeletonTask';
import { WorkflowTasks } from '../../services/WorkflowTasks';
import ContentPlain from '../../../../components/layout/ContentPlain';
import { useSelector, shallowEqual, useDispatch } from 'react-redux';
import { TicketState } from '../../services/TicketState';
import DateTime from '../../../../components/library/common/DateTime';

const Workflow = (props) => {
    const ticket = useSelector(state => state.tickets.selectedTicket, shallowEqual)
    const closedDate = useSelector(state => {
        var t = state.tickets.selectedTicket;
        if (t) { 
            var currStatus = t.ticketState.identifier
            if (t.stateTransitions && t.stateTransitions.length > 0
                && t.stateTransitions[0].finalState.identifier === currStatus
                && t.stateTransitions[0].timestamp) {
                return t.stateTransitions[0].timestamp
            } else {
                return t.lastModified
            }
        }
        return null;        
    })
        
    return (
        <ContentPlain elementId='workflow-tab'>
            <div className='columns level workflow'>
                <div className='column is-7 is-offset-1'>
                    <div>
                        <h3><HrbTranslate text='Tickets.Tasks.Tasks' /></h3>
                    </div>
                </div>
            </div>
            {ticket && ticket.ticketState.identifier !== TicketState.OPEN && ticket.ticketState.identifier !== TicketState.CLOSED &&
                <div className='columns level workflow'>
                    <div className='column is-10 is-offset-1'>
                        <div>
                        {ticket.ticketState.identifier === TicketState.CLOSED_COMPLETED_IN_OFFICE &&
                            <p className='p1'><HrbTranslate text='Tickets.Closed.CompletedInOffice'
                                params={{ TimeStamp: <DateTime value={closedDate} dateAndTime /> }}/></p>
                        }
                        {ticket.ticketState.identifier === TicketState.CLOSED_INCOMPLETE &&
                            <p className='p1'><HrbTranslate text='Tickets.Closed.Incomplete'
                                params={{ TimeStamp: <DateTime value={closedDate} dateAndTime /> }}/></p>
                        }
                        </div>
                    </div>
                </div>
            }
            {ticket &&
                <Fragment>
                    <ClientInterviewTask ticket={ticket} />
                    <IdentityConfirmationTask ticket={ticket} />
                    <AuthorizationTask ticket={ticket} />
                    <DocumentUploadTask ticket={ticket} />
                    <div id='PrepareReturn' className='task-shim'>
                        <PrepareReturnTask ticket={ticket} />
                    </div>
                    <PaymentTask ticket={ticket} />
                    <ReviewReturnTask ticket={ticket} />
                    <FileReturnTask ticket={ticket} />
                </Fragment>
            }
            {!ticket &&
                <Fragment>
                    <SkeletonTask taskId={WorkflowTasks.INTERVIEW_COMPLETED} />
                    <SkeletonTask taskId={WorkflowTasks.CONFIRM_ID} />
                    <SkeletonTask taskId={WorkflowTasks.AUTHORIZE_CRA} />
                    <SkeletonTask taskId={WorkflowTasks.DOCS_UPLOADED} />
                    <SkeletonTask taskId={WorkflowTasks.RETURN_PREPARED} />
                    <SkeletonTask taskId={WorkflowTasks.RETURN_REVIEWED} />
                    <SkeletonTask taskId={WorkflowTasks.PAYMENT_RECEIVED} />
                    <SkeletonTask taskId={WorkflowTasks.RETURN_FILED} />
                </Fragment>
            }
        </ContentPlain>
    );
}

Workflow.whyDidYouRender = false;

export default Workflow